<template>
  <b-datetimepicker
    :value="localValue"
    @input="onInput"
    :datetime-formatter="formatDateTime"
    rounded
    placeholder="placeholder"
    icon="calendar-today"
    horizontal-time-picker
    datetime
  ></b-datetimepicker>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: String
    },

    placeholder: {
      type: String
    }
  },

  data() {
    return {
      localValue: this.value ? new Date(this.value) : null
    };
  },

  watch: {
    value() {
      this.localValue = this.value ? new Date(this.value) : null;
    }
  },

  methods: {
    onInput(value) {
      let date = moment(value).format("YYYY-MM-DD HH:mm:ss");

      this.$emit("input", date);
    },

    formatDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    }
  }
};
</script>
